
const headings = {
    "ageGroups": "Age Groups",
    "genders": "Genders"
}

const stats = [
    { name: 'Total Subscribers', stat: '71,897' },
    { name: 'Avg. Open Rate', stat: '58.16%' },
    { name: 'Avg. Click Rate', stat: '24.57%' },
]

function QuestionAndAnswers({data}) {
    const answers = data.answers;
    return (<>
        <p>{data.question}</p>
        <p>1 (least) to 5 (most)</p>
        <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
            {Object.keys(answers).map((key) => {
                return (<div key={key} className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt className="truncate text-sm font-medium text-gray-500">{key}</dt>
                    <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">{answers[key]}</dd>
                </div>);
            })}
        </dl>
    </>);
}

export default function SurveyVisualization({data}) {
    return (
        <div>
            {Object.keys(data).map((question) => {
                return (<div>
                <h4 className="text-base font-semibold leading-6 text-gray-900">{headings[question]}</h4>
                        {data[question].map((surveyAnswers) => {
                            if (surveyAnswers === null) {
                                return null;
                            }
                            return <QuestionAndAnswers data={surveyAnswers} />
                        })}
                </div>);
            })}
        </div>
    )
}